module.exports = __webpack_public_path__ + "b2_zonen.2c6b9f1dc7e6d4aa0feb770cd6f99f2a.png";